export default "/images/vendor/flag-icons/flags/1x1/mt.svg?35575a14235408993f8db74f5169db77";